import {createSimpleContext} from "../../../utils/context.tsx"
import {TDropdownContextValue} from "./types.ts"

export const DropdownContext = createSimpleContext<TDropdownContextValue<unknown>>("dropdown")
